import {DatePipe} from '@angular/common';
import {Component, input, output} from '@angular/core';
import {NotificationType} from '@domain/enum/notification-type.enum';
import {Notification} from '@domain/notification/notification';
import {TranslateModule} from '@ngx-translate/core';
import {CustomButtonComponent} from '@shared/custom-button/custom-button.component';
import {AngularSvgIconModule} from 'angular-svg-icon';

@Component({
    selector: 'app-notification-item',
    templateUrl: './notification-item.component.html',
    styleUrl: './notification-item.component.scss',
    standalone: true,
    imports: [
        AngularSvgIconModule,
        TranslateModule,
        DatePipe,
        CustomButtonComponent
    ]
})
export class NotificationItemComponent
{
    public readonly notification = input.required<Notification>();

    public readonly pressed = output();

    public readonly notificationType = NotificationType;
}
